import {
  BrowserRouter as Router,
  Route,
  Routes,
  Link,
  Navigate,
  useParams,
  useNavigate,
  useSearchParams,
  useLocation,
} from "react-router-dom";
import React, { useState, useEffect } from "react";
import "./styles/App.css";
import { isEmpty } from "./functions/isEmpty";
import useFetch from "./functions/useFetch";

import Home from "./screens/Home";
import useScreenType from "./functions/useScreenType";
import { LanguageProvider } from "./contexts/LanguageContext";
import Imprint from "./screens/Imprint";
import Product from "./screens/Product";
import Cart from "./screens/Cart";
import Checkout from "./screens/Checkout";
import Ordercomplete from "./screens/Ordercomplete";
import AGB from "./screens/AGB";

const developerMode = true;

export default function App() {
  let apiURL = "https://cloud.starthome.ai";
  if (developerMode) {
    apiURL = "https://cloud.starthome.ai";
  }

  /* Auth Token */
  const [authToken, setAuthToken] = useState("");

  /* screen */
  const isMobile = useScreenType();

  /* session Data */
  const [cart, setCart] = useState([]);
  const [language, setLanguage] = useState("Deutsch");
  const [products, setProducts] = useState([]);

  /* userdata */
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [userID, setUserID] = useState(null);

  // neuen nutzer anlegen
  useEffect(async () => {
    if (isEmpty(userID)) {
      const localData = localStorage.getItem("@aibuttonio");
      if (!isEmpty(localData)) {
        setUserID(JSON.parse(localData));
      } else {
        try {
          const resa = await fetch(`${apiURL}/users/create_new_user.php`, {
            method: "GET",
            headers: {
              //   Authorization: `Bearer ${authToken?.JWT}`,
              "Content-type":
                "application/x-www-form-urlencoded; charset=UTF-8",
            },
            //    body: JSON.stringify({            }),
          });
          await resa.text().then((value) => saveNewUser(value));
        } catch (error) {
          console.log(error);
        }
      }
    }
  }, [userID]);

  const saveNewUser = (newUserID) => {
    setUserID(newUserID);
    localStorage.setItem("@aibuttonio", newUserID);
  };

  useEffect(async () => {
    if (isEmpty(products)) {
      try {
        const resa = await fetch(`${apiURL}/products/index.php`, {
          method: "GET",
          headers: {
            //   Authorization: `Bearer ${authToken?.JWT}`,
            "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
          },
          //    body: JSON.stringify({            }),
        });
        await resa.text().then((value) => setProducts(JSON.parse(value)));
      } catch (error) {
        console.log(error);
      }
    }
  }, [products]);

  useEffect(() => {
    if (isEmpty(cart)) {
      let savedCart = localStorage.getItem("starthomeCart");
      if (!isEmpty(savedCart)) {
        setCart(JSON.parse(savedCart));
      }
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("starthomeCart", JSON.stringify(cart));
  }, [cart]);

  /*
  const products = [
    {
      id: 1,
      name: "AI Thermostat",
      price: 10000,
      description: "description",
      image:
        '["product_placeholder.png","product_placeholder.png","product_placeholder.png"]',
    },
    {
      id: 2,
      name: "Smart Lighting Hub",
      price: 7900,
      description: "description",
      image:
        '["product_placeholder.png","product_placeholder.png","product_placeholder.png"]',
    },
    {
      id: 3,
      name: "Security AI Camera",
      price: 9900,
      description: "description",
      image:
        '["product_placeholder.png","product_placeholder.png","product_placeholder.png"]',
    },
    {
      id: 4,
      name: "AI Thermostat",
      price: 10900,
      description: "description",
      image:
        '["product_placeholder.png","product_placeholder.png","product_placeholder.png"]',
    },
    {
      id: 5,
      name: "Smart Lighting Hub",
      price: 14900,
      description: "description",
      image:
        '["product_placeholder.png","product_placeholder.png","product_placeholder.png"]',
    },
    {
      id: 6,
      name: "Security AI Camera",
      price: 22900,
      description: "description",
      image:
        '["product_placeholder.png","product_placeholder.png","product_placeholder.png"]',
    },
    {
      id: 7,
      name: "AI Thermostat",
      price: 19900,
      description: "description",
      image:
        '["product_placeholder.png","product_placeholder.png","product_placeholder.png"]',
    },
    {
      id: 8,
      name: "Smart Lighting Hub",
      price: 14900,
      description: "description",
      image:
        '["product_placeholder.png","product_placeholder.png","product_placeholder.png"]',
    },
    {
      id: 9,
      name: "Security AI Camera",
      price: 10900,
      description: "description",
      image:
        '["product_placeholder.png","product_placeholder.png","product_placeholder.png"]',
    },
    {
      id: 10,
      name: "Cooking Instructor",
      price: 24900,
      description: "description",
      image:
        '["product_placeholder.png","product_placeholder.png","product_placeholder.png"]',
    },
  ];
  */

  const reviews = [
    {
      id: 1,
      title: "I save 5 hours every week.",
      name: "Jonas, Founder",
      comment:
        "Smarthome was never a thing, because it was not as smart as a human, until now. But now with Starthome I started optimizing my daily routine and i love it.",
      image: "user_2.png",
    },
    {
      id: 2,
      title: "I love coming home and start talking.",
      name: "John, Art Student",
      comment:
        "Talking to your home feels good to me. Its like having this best friend at home.",
      image: "user_1.png",
    },
  ];

  const texts = {
    en: {
      banner: "Join the revolution of Home A.I.",

      headline: "Your Home A.I.",
      subheadline_top: "Just say::",
      subheadline_bottom: "Coffeemachine, make me a coffee.",
      hero_cta: "Show products",
      products_headline: "A.I. House Devices",
      products_addtocart: "Add to Cart",
      reputation_headline: "Loved by customers",
      reputation_1:
        "Smarthome was never a thing, because it was not as smart as a human, until now. But now with Starthome I started optimizing my daily routine and i love it.",
      reputation_2:
        "Talking to your home feels good to me. Its like having this best friend at home.",
      socialmedia_headline: "Social Media",
      faq_headline: "Frequently askes questions",
      faq_q1: "Do i have to download an app?",
      faq_a1: "Yes, in the app you can customize the speaking experience.",
      faq_q2: "Are there any additional costs?",
      faq_a2:
        "No, there are no additional costs. But you can buy premium upgrades in the app, but they are not neccesary.",
      agb: "Terms of Service",

      imprint: "Imprint & Data Privacy",
    },
    de: {
      banner: "Werde Teil der K.I. Home Revolution",
      headline: "K.I. in deinem zu Hause",
      subheadline_top: "Sag' einfach:",
      subheadline_bottom: "Kaffeemaschine, mach mir einen Kaffee.",
      hero_cta: "Produkte zeigen",
      products_headline: "K.I. Geräte",
      products_addtocart: "In den Warenkorb",
      reputation_headline: "Von Kunden geliebt",
      reputation_1: "",
      reputation_2: "",
      socialmedia_headline: "Social Media",
      faq_headline: "Häufig gestellte Fragen",
      faq_q1: "Muss ich eine App herunterladen?",
      faq_a1: "Ja in der App kannst du die Sprachsteuerung personalisieren.",
      faq_q2: "Gibt es weitere Kosten?",
      faq_a2:
        "Nein, es gibt keine weiteren Kosten. In der App gibt es Premium-Funktionen die optional erworben werden können.",
      agb: "AGB",

      imprint: "Impressum & Datenschutz",
    },
  };

  return (
    <div className="app">
      <LanguageProvider>
        <Router>
          <Routes>
            <Route
              path="/"
              element={
                <Home
                  apiURL={apiURL}
                  userID={userID}
                  isMobile={isMobile}
                  products={products}
                  reviews={reviews}
                  cart={cart}
                  setCart={setCart}
                  language={language}
                  setLanguage={setLanguage}
                  texts={texts}
                />
              }
            />
            <Route
              path="/product/:id"
              element={
                <Product
                  apiURL={apiURL}
                  userID={userID}
                  isMobile={isMobile}
                  products={products}
                  reviews={reviews}
                  cart={cart}
                  setCart={setCart}
                  language={language}
                  setLanguage={setLanguage}
                  texts={texts}
                />
              }
            />
            <Route
              path="/cart"
              element={
                <Cart
                  apiURL={apiURL}
                  userID={userID}
                  isMobile={isMobile}
                  products={products}
                  reviews={reviews}
                  cart={cart}
                  setCart={setCart}
                  language={language}
                  setLanguage={setLanguage}
                  texts={texts}
                />
              }
            />
            <Route
              path="/checkout"
              element={
                <Checkout
                  apiURL={apiURL}
                  userID={userID}
                  isMobile={isMobile}
                  products={products}
                  reviews={reviews}
                  cart={cart}
                  setCart={setCart}
                  language={language}
                  setLanguage={setLanguage}
                  texts={texts}
                />
              }
            />
            <Route
              path="/ordercomplete"
              element={
                <Ordercomplete
                  apiURL={apiURL}
                  userID={userID}
                  isMobile={isMobile}
                  products={products}
                  reviews={reviews}
                  cart={cart}
                  setCart={setCart}
                  language={language}
                  setLanguage={setLanguage}
                  texts={texts}
                />
              }
            />
            <Route
              path="/agb"
              element={
                <AGB
                  apiURL={apiURL}
                  userID={userID}
                  isMobile={isMobile}
                  language={language}
                  setLanguage={setLanguage}
                  texts={texts}
                />
              }
            />
            <Route
              path="/imprint"
              element={
                <Imprint
                  apiURL={apiURL}
                  userID={userID}
                  isMobile={isMobile}
                  language={language}
                  setLanguage={setLanguage}
                  texts={texts}
                />
              }
            />
          </Routes>
          <></>
        </Router>
      </LanguageProvider>
    </div>
  );
}
